<template>
  <div
    class="d-flex flex-column flex-md-row align-items-center p-3 bg-white"
    id="breadcrumbs"
  >
    <ul>
      <li
        v-for="(breadcrumb, idx) in breadcrumbList"
        :key="idx"
        @click="routeTo(idx)"
        :class="{ linked: !!breadcrumb.link }"
      >
        <img v-if="breadcrumb.icon" :src="iconsDir + breadcrumb.icon" />
        <div>
          {{ breadcrumb.name }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  data() {
    return {
      breadcrumbList: [],
      iconsDir: '/img/icons/'
    }
  },
  computed: {
    icon() {
      return this.breadcrumbList.find(breadcrumb => {
        return breadcrumb.name == this.breadcrumbList.name
      }).icon
    }
  },
  mounted() {
    this.updateList()
  },
  watch: {
    $route() {
      this.updateList()
    }
  },
  methods: {
    routeTo(pRouteTo) {
      if (this.breadcrumbList[pRouteTo].link)
        this.$router.push(this.breadcrumbList[pRouteTo].link)
    },
    updateList() {
      this.breadcrumbList = this.$route.meta.breadcrumb
    }
  }
}
</script>

<style>
#breadcrumbs ul {
  display: flex;
  justify-content: left;
  list-style-type: none;
  margin-bottom: 0;
  padding: 0;
}

#breadcrumbs ul > li {
  display: flex;
  float: left;
  width: auto;
  cursor: default;
  align-items: center;
}

#breadcrumbs ul > li > div {
  padding: 5px;
  transition: background 120ms ease-in 0s;
  border-radius: 3px;
  color: rgb(55, 53, 47);
  font-size: 14px;
  line-height: 1.2;
}

#breadcrumbs ul > li > img {
  display: inline-block;
  object-fit: cover;
  border-radius: 3px;
  width: 17.76px;
  height: 17.76px;
  transition: opacity 100ms ease-out 0s;
}

#breadcrumbs ul > li:not(:last-child)::after {
  content: '/';
  float: right;
  font-size: 14px;
  color: rgba(55, 53, 47, 0.4);
  margin: 0 4px;
  cursor: default;
}

#breadcrumbs .linked {
  cursor: pointer;
  font-size: 14px;
}

#breadcrumbs .linked:hover div {
  background: rgba(55, 53, 47, 0.08);
}
</style>
